import { c as _c } from "react/compiler-runtime";
import { Toaster } from "@repo/ui/components/ui/sonner";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { MotionConfig } from "framer-motion";
import React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Route = createRootRouteWithContext()({
  component: RootComponent
});

// https://tanstack.com/router/v1/docs/framework/react/devtools
const TanStackRouterDevtools = import.meta.env.PROD ? () => null : /*#__PURE__*/React.lazy(() => import("@tanstack/router-devtools").then(res => ({
  default: res.TanStackRouterDevtools
})));
function RootComponent() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsx(Outlet, {});
    t1 = /*#__PURE__*/_jsx(Toaster, {
      position: "top-center"
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsxs(MotionConfig, {
      reducedMotion: "user",
      children: [t0, t1, /*#__PURE__*/_jsx(React.Suspense, {
        children: /*#__PURE__*/_jsx(TanStackRouterDevtools, {
          position: "bottom-right"
        })
      })]
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}